var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonaLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99994 9.88506C10.8368 9.88506 13.1366 7.67221 13.1366 4.94253C13.1366 2.21285 10.8368 0 7.99994 0C5.16304 0 2.86328 2.21285 2.86328 4.94253C2.86328 7.67221 5.16304 9.88506 7.99994 9.88506Z",
    fill: "white",
    fillOpacity: 0.39
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2386 17.3135C10.5516 18.0386 6.68956 18.4014 2.76137 17.3135C1.23143 16.89 0 15.9478 0 14.5955C0 13.2308 1.27502 12.3706 2.80029 11.8729C5.94931 10.845 9.45755 10.721 13.1997 11.8729C14.7343 12.3452 16 13.2308 16 14.5955C16 15.9478 14.7725 16.8997 13.2386 17.3135Z",
    fill: "white",
    fillOpacity: 0.39
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonaLogin);
export default __webpack_public_path__ + "static/media/personaLogin.d87847a1ddf364dd2f4b4bff0b4204b1.svg";
export { ForwardRef as ReactComponent };